import { Irc, Schema } from "../../../../../@types";

export const irc: Schema<Irc> = {
  fields: [
    {
      name: "command",
      displayTitle: "Command",
      sortable: true,
      component: (d: Irc) => <>{d.command}</>
    },
    {
      name: "params",
      displayTitle: "Params",
      sortable: true,
      component: (d: Irc) => <>{d.params}</>
    },
    {
      name: "type",
      displayTitle: "Type",
      sortable: true,
      component: (d: Irc) => <>{d.type}</>
    }
  ]
};
